import React from "react";

const ValetTipOptions = ({ stats }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mx-3">
      <div className="d-flex gap-4">
        <div className="d-flex flex-column align-items-center">
          <div
            className="rounded-circle bg-light text-dark d-flex align-items-center justify-content-center mb-1"
            style={{ width: "32px", height: "32px", fontSize: "0.9rem" }}
          >
            {stats.teamTipOptionSelected}
          </div>
          <div className="small text-muted">Team Tips</div>
        </div>

        <div className="d-flex flex-column align-items-center">
          <div
            className="rounded-circle bg-light text-dark d-flex align-items-center justify-content-center mb-1"
            style={{ width: "32px", height: "32px", fontSize: "0.9rem" }}
          >
            {stats.directTipOptionSelected}
          </div>
          <div className="small text-muted">Direct Tips</div>
        </div>
      </div>
    </div>
  );
};

export default ValetTipOptions;
